import { css, type Theme } from "@emotion/react";

const orSectionBase = (theme: Theme) => css`
  margin: 1rem 0;
  color: ${theme.system.borderHover};
  overflow: hidden;
  text-transform: uppercase;

  &:before,
  &:after {
    background-color: ${theme.system.borderHover};
    content: "";
    height: 1px;
  }
`;

export const orSection = (theme: Theme) => css`
  ${orSectionBase(theme)}

  &:before,
  &:after {
    display: inline-block;
    position: relative;
    vertical-align: middle;
    width: 25%;
  }

  &:before {
    right: 0.5rem;
    margin-left: -50%;
  }

  &:after {
    left: 0.5rem;
    margin-right: -50%;
  }
`;

export const orSectionFullWidth = (theme: Theme) => css`
  ${orSectionBase(theme)}
  display: flex;
  align-items: center;
  width: 100%;

  &:before,
  &:after {
    display: block;
    flex: 1;
  }

  &:before {
    margin-right: ${theme.ds5.gap[300]};
  }

  &:after {
    margin-left: ${theme.ds5.gap[300]};
  }
`;
